import React from "react";

import Container from "@material-ui/core/Container";
import ApplicationPanel from "../application/ApplicationPanel";
import ApplicationHeader from "../application/ApplicationHeader";
import ContentProvidersBrowse from "./ContentProvidersBrowse";
import { useContentProviders } from "./contentProviderServices";

const ManageContentProvidersView = () => {
  const contentProvidersResult = useContentProviders();

  return (
    <Container id="manage-content-providers" disableGutters>
      <ApplicationHeader />

      <ApplicationPanel>
        <ContentProvidersBrowse
          results={contentProvidersResult}
        />
      </ApplicationPanel>
    </Container>
  );
};

export default ManageContentProvidersView;
